import PropTypes from "prop-types"
import React, { Component } from "react"

import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Layout as AntLayout, Drawer } from "antd"
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  getAppMenus,
  getUserBalance,
  getUserInfo,
} from "../../store/actions"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    }
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this)
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  componentDidMount() {
    this.props.getAppMenus()
    this.props.getUserBalance()
    this.props.getUserInfo()

    // Scroll Top to 0
    window.scrollTo(0, 0)
    // let currentage = this.capitalizeFirstLetter(this.props.location.pathname)

    // document.title =
    //   currentage + " | electUnit - Responsive Bootstrap 5 Admin Dashboard"
    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme)
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth)
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType)
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme)
    }
  }
  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === "default") {
      this.props.changeSidebarType("condensed", this.state.isMobile)
    } else if (this.props.leftSideBarType === "condensed") {
      this.props.changeSidebarType("default", this.state.isMobile)
    }
  }

  render() {
    return (
      <>
        <Header toggleMenuCallback={this.toggleMenuCallback} />
        <AntLayout style={{ minHeight: "100vh", paddingTop: 64 }}>
          {this.state.isMobile ? (
            // Mobile: use Drawer overlay for sidebar
            <>
              <Drawer
                placement="left"
                open={this.props.leftSideBarType === "default"}
                onClose={() => this.props.changeSidebarType("condensed", true)}
                width={260}
                styles={{ body: { padding: 0 } }}
                destroyOnClose
              >
                <Sidebar
                  theme={this.props.leftSideBarTheme}
                  type={this.props.leftSideBarType}
                  isMobile={this.state.isMobile}
                  appMenus={this.props.lstAppMenu}
                  userBalance={this.props.userBalance}
                  userInfo={this.props.userInfo}
                />
              </Drawer>
              <AntLayout>
                <AntLayout.Content>{this.props.children}</AntLayout.Content>
              </AntLayout>
            </>
          ) : (
            // Desktop: persistent sider
            <AntLayout hasSider>
              <AntLayout.Sider
                theme={
                  this.props.leftSideBarTheme === "dark" ? "dark" : "light"
                }
                width={260}
                collapsedWidth={80}
                collapsed={this.props.leftSideBarType === "condensed"}
                trigger={null}
              >
                <Sidebar
                  theme={this.props.leftSideBarTheme}
                  type={this.props.leftSideBarType}
                  isMobile={this.state.isMobile}
                  appMenus={this.props.lstAppMenu}
                  userBalance={this.props.userBalance}
                  userInfo={this.props.userInfo}
                />
              </AntLayout.Sider>
              <AntLayout>
                <AntLayout.Content
               style={{padding:"1rem"}}
                >{this.props.children}</AntLayout.Content>
              </AntLayout>
            </AntLayout>
          )}
        </AntLayout>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state.Layout,
    ...state.AppMenus,
    ...state.USERs,
  }
}
export default connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  getAppMenus,
  getUserBalance,
  getUserInfo,
})(withRouter(Layout))
